import {FC, Form} from 'external/react'
import FormTextfield, { PasswordField } from 'components/FormTextfield'
import useParent from 'context/parent-context/hook'

type UserProfileFormProps =  {
	errors: any
}

const UserProfileForm: FC<UserProfileFormProps> = props => {

	const {errors} = props

	const {update, state: {userProfile}} = useParent()

	function createFieldProps (placeholder: any, fieldName: string | number, maxLength?: any) {
		return {
			placeholder,
			maxLength,
			fieldName,
			value: userProfile[fieldName],
			submitted: errors.submitted,
			error: errors[fieldName],
			onChange: (e: { target: { value: string } }) => {
				update({userProfile: {[fieldName]: {$set: e.target.value}}})
			}
		}
	}

    return (
			<Form>
					<LabeledTextField label='Correo electrónico' {...createFieldProps('Email', 'email', 255)} controlProps={{readOnly: true}} />
					<LabeledTextField label='Nombre' {...createFieldProps('Nombre', 'first_name', 25)} />
					<LabeledTextField label='Apellido'{...createFieldProps('Apellido', 'last_name', 25)} />
					<LabeledTextField label='Teléfono' {...createFieldProps('Télefono', 'phone')} />
			</Form>
    )
}

function LabeledTextField (props) {
	const {label} = props
	return (
		<div className='col-md-6 mt-2'>
			<Form.Label className='d-flex flex-column justify-content-center col-sm-6'>{label}</Form.Label>
			<FormTextfield {...props} />
		</div>
	)
}

export {UserProfileForm as default}